import React from "react";
import { renderHTML } from "../../utils/misc";
import { buildImgUrl } from "../../utils/misc";
import Slider from "react-slick";
import { defineMessages, FormattedMessage } from "react-intl";
import classnames from "classnames";
import styles from "./MobileGallery.scss";
import PropTypes from "prop-types";
import { ArrowRightIcon, ArrowLeftIcon } from "../../theme/assets";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ArrowContainer } from "../../utils/ArrowContainer";
import { SmartImage } from "@witbooking/react-components";

const msgs = defineMessages({
  book: {
    id: "room_selection.gallery.book",
    description: "book",
    defaultMessage: "book",
  },
  close: {
    id: "bookingModification.modal.close",
    description: "close",
    defaultMessage: "close",
  },
});
/**
 * @return {null}
 */
class NextArrow extends React.Component {
  constructor(props) {
    super(props);
    this.escFunction = this.escFunction.bind(this);
  }
  componentDidMount() {
    document.addEventListener("keydown", this.escFunction, false);
  }
  componentWillUnmount() {
    document.removeEventListener("keydown", this.escFunction, false);
  }

  onClick(event) {
    this.props.onClick(event);
  }
  escFunction(event) {
    if (event.keyCode === 39) {
      this.onClick(event);
    }
  }

  render() {
    return (
      <ArrowContainer {...this.props}>
        <div className={"nextArrow"} onClick={this.props.onClick}>
          <ArrowRightIcon />
        </div>
      </ArrowContainer>
    );
  }
}

class PrevArrow extends React.Component {
  constructor(props) {
    super(props);
    this.escFunction = this.escFunction.bind(this);
  }
  componentDidMount() {
    document.addEventListener("keydown", this.escFunction, false);
  }
  componentWillUnmount() {
    document.removeEventListener("keydown", this.escFunction, false);
  }
  onClick(event) {
    this.props.onClick(event);
  }
  escFunction(event) {
    if (event.keyCode === 37) {
      this.onClick(event);
    }
  }
  render() {
    return (
      <ArrowContainer {...this.props}>
        <div className={"prevArrow"} onClick={this.props.onClick}>
          <ArrowLeftIcon />
        </div>
      </ArrowContainer>
    );
  }
}
NextArrow.propTypes = {
  onClick: PropTypes.func,
};
PrevArrow.propTypes = {
  onClick: PropTypes.func,
};
function MobileGallery({
  isOpen,
  imageList,
  title,
  description,
  inventory,
  type,
  handleClose,
  handleInventory,
  contentBucketBaseUrl,
  infoOnly,
}) {
  if (!isOpen) {
    return null;
  }
  const sliderSettings = {
    accessibility: true,
    autoplay: false,
    autoplaySpeed: 5000,
    centerMode: false,
    infinite: true,
    lazyLoad: true,
    slidesToScroll: 1,
    slidesToShow: 1,
    speed: 500,
    swipe: true,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };
  let maxHeight = 0;
  imageList.map(image => {
    const img = document.createElement("img");
    img.onload = () => {
      console.log(img.naturalHeight);
      if (maxHeight < img.naturalHeight) {
        maxHeight = img.naturalHeight;
      }
    };
    img.src = image.url;
  });

  function closeModal() {
    document.removeEventListener("keydown", closeModal, false);
    handleClose();
  }
  document.addEventListener(
    "keydown",
    () => {
      if (event.keyCode === 27) {
        closeModal();
      }
    },
    false
  );
  return (
    <div
      id="photoSwipeCustom"
      className={classnames(
        "wbkv9-MobileGallery-container",
        "pswp__ui--fit",
        "pswp__bg",
        styles.container
      )}>
      <div className={classnames("wbkv9-MobileGallery-topNav", "pswp__top-bar", styles.topNav)}>
        <div
          className={classnames("wbkv9-MobileGallery-closeButton", styles.closeButton)}
          onClick={closeModal}
          id="my_movie"
        />
      </div>
      <div className={classnames("wbkv9-MobileGallery-content", styles.content)}>
        <div className={classnames("wbkv9-MobileGallery-slider", styles.slider)}>
          <Slider {...sliderSettings}>
            {imageList.map(image => (
              <div>
                {image.url.startsWith(contentBucketBaseUrl) && (
                  <SmartImage
                    imageUrl={image.url}
                    contentBucketBaseUrl={contentBucketBaseUrl}
                    sizes={["100vw"]}
                  />
                )}
                {!image.url.startsWith(contentBucketBaseUrl) && (
                  <img src={buildImgUrl(image.url, 559, 993, "https://placehold.it/993x559")} />
                )}
              </div>
            ))}
          </Slider>
        </div>
        <div
          className={classnames(
            "wbkv9-MobileGallery-descriptionContainer",
            styles.descriptionContainer
          )}>
          <div className={classnames("wbkv9-MobileGallery-title", styles.title)}>{title}</div>
          <div
            className={classnames("wbkv9-MobileGallery-description", styles.description)}
            dangerouslySetInnerHTML={renderHTML(description)}
          />
          {type !== "service" && (
            <div
              onClick={event => {
                event.preventDefault();
                event.stopPropagation();
                handleInventory(inventory && inventory.ticker, inventory && inventory.callback);
              }}>
              <div className={classnames("bookButtonContainer", styles.bookButtonContainer)}>
                <button>
                  {infoOnly ? (
                    <FormattedMessage {...msgs.close} />
                  ) : (
                    <FormattedMessage {...msgs.book} />
                  )}
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

class WrappedMobileGallery extends React.PureComponent {
  render() {
    return (
      <MobileGallery contentBucketBaseUrl={this.context.contentBucketBaseUrl} {...this.props} />
    );
  }
}

WrappedMobileGallery.contextTypes = {
  contentBucketBaseUrl: PropTypes.string.isRequired,
};

export default WrappedMobileGallery;
